import React from 'react';

class ConsentPopup extends React.Component {

    componentDidMount() {
        const params = new URLSearchParams(window.location.hash.replace('#/auth-start', ''));
        const authId = params.get('authId');
        const method = params.get('oauthRedirectMethod');
        const redirectUrl = encodeURIComponent(params.get('hostRedirectUrl')!);
    
        const authorityUrl: string  = process.env.REACT_APP_CD_AUTHORITY!;
        const appClientId: string = process.env.REACT_APP_CD_TEAMS_APP_CLIENT_ID!;

        const state = `"authId":${authId}|"method":${method}`;
        const scope = method === "page" ? "CarpeWebApi%20offline_access%20openid%20Roles%20profile" : "CarpeWebApi%20openid%20Roles%20profile"
        const url = `${authorityUrl}connect/authorize?client_id=${appClientId}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&nonce=3cc8eca0aa59e70be58375f817ff976d202GM3xKh&state=${state}&code_challenge=51FaJvQFsiNdiFWIq2EMWUKeAqD47dqU_cHzJpfHl-Q&code_challenge_method=S256`;
        window.location.href = url;
    }

    render() {
      return (
        <div>
          <h1>Authenticating.</h1>
        </div>
      );
    }
}

export default ConsentPopup;